export default __webpack_public_path__ + "static/media/login.95a8dc64.png";